import { useEffect, useState } from "react";
import { PROJECTS } from "@/lib/data";

const API = process.env.REACT_APP_BACKEND_URL;
export const mediaSrc = (u) => (u && u.startsWith("/api/") ? `${API}${u}` : u);

const SECTION_LABELS = {
  overview: "Overview", challenge: "The challenge", strategy: "Strategy", process: "Process",
  solution: "Solution", design_work: "Design work", results: "Results",
};

// Adapts a CMS work document to the shape the existing page templates expect.
export function workToProject(w) {
  if (!w) return null;
  const sections = w.sections || {};
  const story = Object.keys(SECTION_LABELS)
    .filter((k) => sections[k]?.enabled && (sections[k].body || "").trim())
    .map((k, i) => ({ n: String(i + 1).padStart(2, "0"), label: SECTION_LABELS[k], paragraphs: sections[k].body.split(/\n\s*\n/).map((s) => s.trim()).filter(Boolean), image: (w.gallery || [])[i] && !/\.(mp4|webm)(\?|$)/i.test(w.gallery[i]) ? mediaSrc(w.gallery[i]) : undefined }));
  const paras = (w.description || "").split(/\n\s*\n/).filter(Boolean);
  return {
    id: w.id, slug: w.slug, type: w.type, showInSelectedWork: w.show_in_selected_work !== false, title: w.title, client: w.client_name || "", tag: w.tag || (w.type === "case_study" ? "Case Study" : "Project"),
    year: w.year || "", industry: (w.industries_names || [])[0] || "", industries: w.industries_names || [], location: (w.locations_names || [])[0] || "",
    services: w.services_names || [], serviceSlugs: w.services || [], industrySlugs: w.industries || [],
    heroImage: mediaSrc(w.hero_desktop || w.cover_image), heroMobile: mediaSrc(w.hero_mobile), thumb: mediaSrc(w.thumbnail || w.cover_image),
    gallery: (w.gallery || []).length ? w.gallery.map(mediaSrc) : null, summary: w.short_description || "", challenge: paras[0] || w.short_description || "",
    context: paras.slice(1).join("\n\n") || "", result: w.result || "", timeline: w.timeline || "", tagline: w.tagline || null, credits: w.credits || null,
    story: story.length ? story : null,
    quote: sections.testimonial?.enabled && sections.testimonial.quote ? { text: sections.testimonial.quote, by: sections.testimonial.by, role: sections.testimonial.role } : null,
    cta: sections.cta?.enabled ? sections.cta : null, videoUrl: w.video_url, videoFile: mediaSrc(w.video_file), seo: w.seo || {},
    related: (w.related_items || []).map(workToProject), href: `/${w.type === "case_study" ? "case-studies" : "work"}/${w.slug}`,
  };
}

const FALLBACK = PROJECTS.map((p) => ({ ...p, href: `/work/${p.slug}` }));

export function useWorks(query = "") {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/public/works${query}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => alive && setItems(d.map(workToProject)))
      .catch(() => alive && setItems(query ? [] : FALLBACK));
    return () => { alive = false; };
  }, [query]);
  return items;
}

export function useWork(slug) {
  const [state, setState] = useState({ loading: true, work: null, redirect: null });
  useEffect(() => {
    let alive = true;
    setState({ loading: true, work: null, redirect: null });
    fetch(`${API}/api/public/works/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => alive && setState({ loading: false, work: d && !d.redirect ? workToProject(d) : null, redirect: d?.redirect || null }))
      .catch(() => alive && setState({ loading: false, work: null, redirect: null }));
    return () => { alive = false; };
  }, [slug]);
  return state;
}
